var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('highcharts',{ref:"chart",staticStyle:{"width":"100%","height":"100%"},attrs:{"options":_vm.chart_options}})}
var staticRenderFns = []

export { render, staticRenderFns }